/**
 * element-ui组件主题
 *
 * tips:
 *  1. 此处只包含element-ui组件主题
 *  2. 要达到整站主题修改效果, 请确保[import './element-[#17B3A3]/index.css']当前主题色与[/src/assets/scss/_variables.scss]文件中[$--color-primary]属性值一致
 */

  import ('./element-#36A9E1/scss/index.scss') // 基本色
  import ('./element-#36A9E1/scss/global.scss') // 自定义颜色
  import ('./element-#36A9E1/index.css') // 当前主题色



export default {
  list: [
    '#000000', // 黑色
    '#193F88',  // 深蓝色
    '#00838F',  // 深绿色 navbar的颜色为#00838F,#3782DD,#7A4498，其他为黑色
    '#009688',  // navbar的颜色为深绿色，其他为黑色
    '#36A9E1',  // navbar的颜色为淡蓝色，其他为黑色
    '#3782DD',  // navbar的颜色为#3782DD和#7A4498，其他为黑色
  ]
}



// WEBPACK FOOTER //
// ./src/element-ui-theme/index.js